import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useFiscalNotes = (page = 1, term = null, status = null) => useQuery({ queryKey: ['fiscal-notes', page, term, status], queryFn: async () => {
    const callback = await API.get(`/fiscal?page=${page}${term ? `&term=${term}` : ''}${status ? `&status=${status}` : ''}`)
    return callback?.data
}})

export default useFiscalNotes